// extracted by mini-css-extract-plugin
export default {"TemplateList":"template-list_TemplateList__8n4WA","CreateTemplateButton":"template-list_CreateTemplateButton__mVajm"};